<template>
  <!-- prettier-ignore -->
  <div class="basic-slider">
    <label
      v-if="titleLabel"
      for="slider"
      class="basic-slider__title title-1"
      v-text="titleLabel"
    />
    <div class="basic-slider__container">
      <span>{{ min }}</span>
      <div class="basic-slider__wrapper">
        <input
          id="slider"
          v-model.number="model"
          type="range"
          class="slider"
          :class="classes"
          :disabled="disabled"
          :min="min"
          :max="max"
        >
        <div
          class="slider-value"
          :style="sliderValueStyle"
          v-text="model"
        />
      </div>
      <span>{{ max }}</span>
    </div>
    <div
      v-if="isInvalid"
      class="error-message"
      v-text="props.v.minValue.$message"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  // INIT
  const model = defineModel({ type: Number })
  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },

    titleLabel: {
      type: String,
      default: '',
    },

    min: {
      type: Number,
      default: 1,
    },

    max: {
      type: Number,
      default: 100,
    },

    v: {
      type: Object,
      default: () => {},
    },
  })

  // COMPUTED
  const classes = computed(() => {
    return {
      'slider--error': isInvalid.value,
    }
  })

  const sliderValueStyle = computed(() => {
    const percentage = ((model.value - props.min) / (props.max - props.min)) * 100
    return {
      left: `calc(${percentage}% - ${percentage * 0.15}px)`,
    }
  })

  const isInvalid = computed(() => {
    return props.v?.$dirty && props.v?.$invalid
  })
</script>

<style scoped>
.basic-slider {
  display: flex;
  flex-direction: column;
  gap: var(--dotcom-responsive-spacing-res-xxs);

  &__title {
    margin-bottom: var(--dotcom-responsive-spacing-res-xxxs);
  }

  &__container {
    display: flex;
    flex-direction: row;
    gap: var(--dotcom-responsive-spacing-res-xxxs);
    width: 100%;
  }

  &__wrapper {
    position: relative;
    width: 100%;
  }
}
.slider-value {
  position: absolute;
  bottom: 30px;
  padding: 5px;
  font-size: 15px;
  color: var(--Interaction-States-enabled-default);
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  border: none;
  background-color: var(--surface-ext-b-low);
  border-radius: var(--radius-border-radius-full);
  height: var(--fixed-spacing-fix-04);
  margin-right: var(--dotcom-responsive-spacing-res-xs);
}

.error-message {
  color: var(--error);
  font-size: var(--font-size-regular-xs);
}

.slider:hover {
  opacity: 1;
}

.slider--error::-webkit-slider-thumb {
  background-color: var(--error);
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--Interaction-States-enabled-default);
  cursor: pointer;
  box-shadow: var(--elevation-level-3);
  transition:
    background-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.slider::-webkit-slider-thumb:hover {
  background-color: var(--tertiary);
  box-shadow: var(--elevation-level-2);
}
.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--Interaction-States-enabled-default);
  cursor: pointer;
  box-shadow: var(--elevation-level-3);
  transition:
    background-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.slider::-moz-range-thumb:hover {
  background-color: var(--tertiary);
  box-shadow: var(--elevation-level-2);
}
.slider::-ms-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--Interaction-States-enabled-default);
  cursor: pointer;
  box-shadow: var(--elevation-level-2);
  transition:
    background-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.slider::-ms-thumb:hover {
  background-color: var(--tertiary);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
}

@media (--v-medium) {
  /* .basic-slider__container {
    padding-right: 10%;
  } */
}
</style>
